import Sections from './Sections.js'
import {Power0, Power2, Power3, Power4, Back, Bounce, Circ, Elastic, Expo, Linear, RoughEase, Sine, SlowMo, SteppedEase} from 'gsap'
function isTablet () {
  return document.querySelector('#is_tablet_value_container').innerHTML.toString() === 'true'
}
function isMobile () {
  var trueOrFale = false
  if (document.querySelector('#is_mobile_value_container')) {
    trueOrFale = document.querySelector('#is_mobile_value_container').innerHTML.toString() === 'true'
  } else if (document.querySelector('#editormobileemulator')) {
    trueOrFale = document.querySelector('#editormobileemulator').innerHTML.toString() === 'true'
  }
  return trueOrFale || Sections.shouldStack()
}
function getWindowSize () {
  var size = isMobile() ? {width: window.innerWidth, height: getMinHeight()} : {width: window.innerWidth, height: window.innerHeight}
  return size
}
function getMinHeight () {
  return 600
}
function getMinWidth () {
  return 1200
}
function getMobileHeight () {
  return 600
}
function getHeight () {
  var actualHeight = isMobile() ? getMinHeight() : window.innerHeight
  return actualHeight
  // return actualHeight < getMinHeight() ? getMinHeight() : actualHeight
}
function getWidth () {
  var actualWidth = window.innerWidth
  return actualWidth
  // return actualWidth < getMinWidth() ? getMinWidth() : actualWidth
}
function getMainScrollElement () {
  var userAgent = window.navigator.userAgent
  return navigator.appVersion.indexOf('Edge') !== -1 || userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) ? document.getElementsByTagName('body')[0] : document.getElementsByTagName('html')[0]
}
function getEasing (option, direction) {
  var ease = Sine
  switch (option) {
    case EasingOptions.LINEAR:
    {
      ease = Linear
      break
    }
    case EasingOptions.SINE:
    {
      ease = Sine
      break
    }
    case EasingOptions.BACK:
    {
      ease = Back
      break
    }
    case EasingOptions.POWER0:
    {
      ease = Power0
      break
    }
    case EasingOptions.POWER2:
    {
      ease = Power2
      break
    }
    case EasingOptions.POWER3:
    {
      ease = Power3
      break
    }
    case EasingOptions.POWER4:
    {
      ease = Power4
      break
    }
    case EasingOptions.CIRC:
    {
      ease = Circ
      break
    }
    case EasingOptions.EXPO:
    {
      ease = Expo
      break
    }
    case EasingOptions.ROUGHEASE:
    {
      ease = RoughEase
      break
    }
    case EasingOptions.SLOWMO:
    {
      ease = SlowMo
      break
    }
    case EasingOptions.STEPPEDEASE:
    {
      ease = SteppedEase
      break
    }
    case EasingOptions.BOUNCE:
    {
      ease = Bounce
      break
    }
    case EasingOptions.ELASTIC:
    {
      ease = Elastic
      break
    }
  }
  var formula = ease.easeInOut
  switch (direction) {
    case EasingDirections.IN:
    {
      formula = ease.easeIn
      break
    }
    case EasingDirections.OUT:
    {
      formula = ease.easeOut
      break
    }
    case EasingDirections.INOUT:
    {
      formula = ease.easeInOut
      break
    }
  }
  return formula
}
const EasingOptions = {
  LINEAR: 0,
  SINE: 16,
  BACK: 8,
  BOUNCE: 2,
  ELASTIC: 1,
  POWER0: 3,
  POWER1: 4,
  POWER2: 5,
  POWER3: 6,
  POWER4: 7,
  CIRC: 9,
  EXPO: 11,
  ROUGHEASE: 15,
  SLOWMO: 18,
  STEPPEDEASE: 19
}
const EasingDirections = {
  IN: 0,
  OUT: 1,
  INOUT: 2
}
const BackgroundRevealOptions = {
  LEFT: -50,
  RIGHT: 50
}
const TextAlignments = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
}
const Fonts = {
  HELVETICA: 'Helvetica',
  TIMES: 'Times',
  VERDANA: 'Verdana',
  CENTURY_GOTHIC: 'CenturyGothic',
  CENTURY_GOTHIC_BOLD_ITALIC: 'CenturyGothic-BoldItalic',
  ARIAL_NARROW: 'ArialNarrow',
  ARIAL_NARROW_BOLD: 'ArialNarrow-Bold',
  SEGOE_REGULAR: 'Segoe Regular',
  SEGOE_BLACK: 'Segoe Black',
  SEGOE_LIGHT: 'Segoe Light',
  SEGOE_BOLD: 'Segoe Bold',
  NUNITO_MEDIUM: 'Nunito-Medium',
  GOTHAM_LIGHT: 'Gotham-Light',
  GOTHAM: 'Gotham-Book',
  GOTHAM_BOLD: 'Gotham-Bold',
  CALLUNA: 'Calluna',
  CALLUNA_LIGHT: 'Calluna-Light',
  CALLUNA_LIGHT2: 'Calluna-Regula'
}
const Modals = {
  ADD_WIDGET: 'add_widget',
  DELETE_WIDGET: 'delete_widget',
  ADD_SECTION: 'add_section',
  DELETE_SECTION: 'delete_section',
  DELETE_PROPERTY: 'delete_property'
}
function hexToRGB (h) {
  var noHash = h.charAt(0) === '#' ? h.substring(1, 7) : h
  var r = parseInt(noHash.substring(0, 2), 16)
  var g = parseInt(noHash.substring(2, 4), 16)
  var b = parseInt(noHash.substring(4, 6), 16)
  return {r: r, g: g, b: b}
}
function getBaseURL () {
  return document.getElementById('baseasseturlcontainerelement').innerHTML.split('static/image')[0]
}
function getSources () {
  var sources = {}
  var sourceContainer = document.getElementById('editorimagelistcontainer')
  if (sourceContainer) {
    var sourcesString = sourceContainer.innerHTML
    var sourceSplit = sourcesString.split(',')
    for (var i = 0; i < sourceSplit.length; i++) {
      var sourceSplitChunks = sourceSplit[i].split('/')
      var sourceKey = sourceSplitChunks[sourceSplitChunks.length - 2] + '_' + sourceSplitChunks[sourceSplitChunks.length - 1].split('.')[0]
      sources[sourceKey] = sourceSplit[i]
    }
  }
  return sources
}
function removeProperty (property, obj) {
  var copy = {}
  for (var o in obj) {
    if (o !== property) {
      copy[o] = obj[o]
    }
  }
  return copy
}
const Sources = getSources()
const EnumMatrix = {
  font: Fonts,
  easeOption: EasingOptions,
  easeDirection: EasingDirections,
  src: Sources,
  alignment: TextAlignments
}
function getKeys (obj) {
  var keys = []
  for (var o in obj) {
    keys.push(o)
  }
  return keys
}
function getElementCenter (el) {
  var bounds = el.getBoundingClientRect()
  return {x: bounds.left + (bounds.width / 2), y: bounds.top + (bounds.height / 2)}
}
function getMouseParams (e) {
  return {x: e.pageX, y: e.pageY}
}
function generateID () {
  return '_' + Math.random().toString().split('.').join('') + Math.random().toString().split('.').join('') + Math.random().toString().split('.').join('')
}
function getAppVersion () {
  return document.querySelector('#applicationversion').innerHTML
}
const InputTypes = {
  TEXT: 'text',
  NUMBER: 'number',
  SELECT: 'select'
}
const GeneralUtils = {
  getHeight: getHeight,
  getWidth: getWidth,
  getMinHeight: getMinHeight,
  getMinWidth: getMinWidth,
  getWindowSize: getWindowSize,
  getMainScrollElement: getMainScrollElement,
  EasingOptions: EasingOptions,
  BackgroundRevealOptions: BackgroundRevealOptions,
  EasingDirections: EasingDirections,
  getEasing: getEasing,
  isTablet: isTablet,
  isMobile: isMobile,
  getBaseURL: getBaseURL,
  Fonts: Fonts,
  EnumMatrix: EnumMatrix,
  getKeys: getKeys,
  InputTypes: InputTypes,
  Sources: Sources,
  TextAlignments: TextAlignments,
  removeProperty: removeProperty,
  getElementCenter: getElementCenter,
  getMouseParams: getMouseParams,
  generateID: generateID,
  Modals: Modals,
  hexToRGB: hexToRGB,
  getMobileHeight: getMobileHeight,
  getAppVersion: getAppVersion
}
export default GeneralUtils



// WEBPACK FOOTER //
// ./src/components/utils/GeneralUtils.js